import React from 'react'
import {useCookies} from "react-cookie";

export default function UpdateCookieOnChange ({ name, children, value = null, onChange }) {
  const [cookies, setCookie] = useCookies([name]);

  const handleOnChange = (fieldValue) => {
    setCookie(name, fieldValue, { path: '/' });
  }

  return React.Children.map(children, child => {
    return React.cloneElement(child, { ...(child.props || {}), onChange: handleOnChange })
  })
}
